import { Component, inject } from '@angular/core';
import { MainProcessService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MainProcessCreateDto,
  MainProcessDto,
  MainProcessExcelDownloadDto,
  MainProcessUpdateDto,
} from '../proxy/general/dtos/main-process';
import { MAINPROCESS_CONFIG, MAINPROCESS_FIELDS } from './main-process.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-main-process',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MainProcessService, ConfirmationService],
  templateUrl: './main-process.html',
  styleUrl: './main-process.scss',
})
export class MainProcess extends BaseCrudComponent<
  MainProcessDto,
  MainProcessCreateDto,
  MainProcessUpdateDto,
  MainProcessExcelDownloadDto
> {
  service = inject(MainProcessService);
  config = MAINPROCESS_CONFIG;
  fields = MAINPROCESS_FIELDS;

  protected prepareUpdateDto(data: any, selected: MainProcessDto): MainProcessUpdateDto {
    return {
      name: data.name,
      code: data.code,
      fundamentalProcessId: data.fundamentalProcessId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MainProcess';
  }
}
